/** @format */

import { ActivatedRouteSnapshot, Params, Resolve } from '@angular/router';
import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { ReviewReturn } from './../model/review.interface';
import { ReviewService } from '../service/review.service';
import { Store } from '@ngrx/store';
import { selectKillswitch } from '@pdp/data-access/state';
import { setProductReviewState } from '../+state';

@Injectable({
	providedIn: 'root'
})
export class ProductReviewsResolver implements Resolve<ReviewReturn> {
	private readonly ngrxStore = inject(Store);
	private readonly reviewService = inject(ReviewService);

	reviewsSEOClient = this.ngrxStore.selectSignal(selectKillswitch('reviewsSEOClient'));
	isNewReviewsEnabled = this.ngrxStore.selectSignal(selectKillswitch('isNewReviewsEnabled'));
	readonly reviewsOff = this.ngrxStore.selectSignal(selectKillswitch('reviewsOff'));
	productIdentifier: string;

	constructor() {}

	resolve(route: ActivatedRouteSnapshot): Observable<ReviewReturn | null> {
		if (this.reviewsOff()) {
			return of(null);
		}

		this.productIdentifier = this.getProductIdentifierFromRoute(route.params);
		if (!!this.productIdentifier && this.reviewsSEOClient()) {
			const options = this.isNewReviewsEnabled()
				? { sortBy: 'SubmissionTime:desc', limitTo: 5 }
				: { sortBy: 'SubmissionTime:desc', limitTo: 15 };
			return this.reviewService.getReviews$(this.productIdentifier, options).pipe(
				tap((reviewResponse) => {
					this.ngrxStore.dispatch(
						setProductReviewState({
							productIdentifier: this.productIdentifier,
							reviewSummary: reviewResponse.reviewSummary,
							reviews: reviewResponse.reviews,
							product: reviewResponse.product
						})
					);
				}),
				catchError(() => of(null))
			);
		} else {
			return of(null);
		}
	}

	private getProductIdentifierFromRoute(routeParams: Params): string {
		return routeParams['partNumber'] ? routeParams['partNumber'] : '';
	}
}
